import { Box, Checkbox } from '@mui/material'
import { styles } from './OrganizationCard.styles'

interface Props {
  name: string
  checked: boolean
  disabled: boolean
  lockedByRole?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void
  dataTestId: string
}

const stateStyleFor = (checked: boolean, lockedByRole: boolean): object => {
  if (lockedByRole) return styles.functionStateLocked
  return checked ? styles.functionStateOn : styles.functionStateOff
}

// The track half is what makes a switch read as a control, so anything that cannot be changed drops it
// and shows the state cell alone, and a role-locked cell is greyed on top of that — the viewer can see
// the grant without being offered a control that would silently refuse.
const stateBox = (checked: boolean, disabled: boolean, lockedByRole: boolean): JSX.Element => {
  const state = <Box
    sx={stateStyleFor(checked, lockedByRole)}
    data-testid={lockedByRole ? 'switchLocked' : undefined}
  >
    {checked ? 'On' : 'Off'}
  </Box>
  const track = <Box sx={styles.functionStateTrack} data-testid='switchTrack' />

  return <Box sx={checked || lockedByRole ? styles.functionSwitch : styles.functionSwitchOff}>
    {!disabled && checked && track}
    {state}
    {!disabled && !checked && track}
  </Box>
}

export const FunctionToggle = (props: Props): JSX.Element =>
  <Checkbox
    checked={props.checked}
    disabled={props.disabled}
    onChange={props.onChange}
    inputProps={{ 'aria-label': props.name }}
    icon={stateBox(false, props.disabled, props.lockedByRole === true)}
    checkedIcon={stateBox(true, props.disabled, props.lockedByRole === true)}
    sx={styles.functionToggle}
    data-testid={props.dataTestId}
  />
